<template>
  <el-cascader
    ref="cascader"
    v-model="ids"
    clearable=""
    :props="props"></el-cascader>
</template>
<script>
export default {
  name: 'DepartmentStaffSelect',
  props: {
    value: {
      required: true
    }
  },
  data() {
    return {
      props: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node
          if (level === 0) {
            this.getdepartments(resolve)
          } else {
            this.getdepartmentstaffs(node.data.departmentId, resolve)
          }
        }
      }
    }
  },
  computed: {
    ids: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  mounted() {
    setTimeout(() => {
      console.log(this.$refs.cascader)
    }, 2000)
  },
  methods: {
    filterMethod(node, keyword) {
      console.log(node, keyword)
      return false
    },
    getdepartments(resolve) {
      this.$store.dispatch('vendor/getdepartments', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          isSaleBranch: 1,
          hasStaff: 1
        },
        success: (res) => {
          const records = res.data.records.map(i => {
            return {
              departmentId: i.departmentId,
              value: i.departmentNumber,
              label: i.departmentName,
              leaf: false
            }
          })
          resolve(records)
        },
        fail: () => {
          resolve([])
        }
      })
    },
    getdepartmentstaffs(departmentId, resolve) {
      this.$store.dispatch('vendor/getdepartmentstaffs', {
        payload: { departmentId },
        success: (res) => {
          const records = res.data.records.map(i => {
            return {
              staffId: i.staffId,
              value: i.staffNumber,
              label: i.staffName,
              leaf: true
            }
          })
          resolve(records)
        },
        fail: () => {
          resolve([])
        }
      })
    }
  }
}
</script>
